module.exports = __webpack_public_path__ + "static/media/techniqo.d7fb471b.png";